import { formatDate } from '@fukuri-admins/utils/common/date';
import { useState } from 'react';
import { Calendar } from '../../../Calendar';
import { CalendarIcon } from '../../../Icons';
import { Popover, PopoverContent, PopoverTrigger } from './Popover';
import styles from './styles.module.scss';

type Props = {
  value: Date | undefined;
  disabled?: boolean;
  fromDate?: Date;
  toDate?: Date;
  /** 日付単位で選択不可にする判定関数（true を返した日付が disabled になる） */
  disabledDate?: (date: Date) => boolean;
  onChange?: (date: Date | undefined) => void;
  onBlur?: () => void;
};

export const DatePicker: React.FC<Props> = ({
  value,
  disabled,
  fromDate,
  toDate,
  disabledDate,
  onChange,
  onBlur,
}) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState<Date | undefined>(value);

  const handleChange = (date: Date | undefined) => {
    setOpen(false);
    setDate(date);
    onChange?.(date);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type='button'
          className={styles.datePickerTrigger}
          disabled={disabled}
          onBlur={onBlur}
        >
          <span className={styles.datePickerTriggerText}>
            {date ? formatDate({ date, formatType: 'yyyy年M月d日' }) : '年/月/日'}
          </span>
          <CalendarIcon size='sm' aria-hidden />
        </button>
      </PopoverTrigger>
      <PopoverContent align='start' className={styles.popoverContent}>
        <Calendar
          selected={date}
          onSelect={handleChange}
          captionLayout='label'
          fromDate={fromDate}
          toDate={toDate}
          disabledDate={disabledDate}
        />
      </PopoverContent>
    </Popover>
  );
};
